import gt from 'lodash/fp/gt';
import isNil from 'lodash/fp/isNil';
import { FormattedMessage } from 'react-intl';
import { Unit } from '../../../common/constants';
import {
    convertISOToRelativeDate,
    convertSecondsIntoHHmmDisplay,
    getBatteryColor,
    getBatteryIcon,
} from '../../../common/utils';
import { RangeStatusIcon } from '../../../components/RangeStatusIcon/RangeStatusIcon';

export type StopoverInfo = {
    locale: string;
    arrivalTime?: string;
    address?: string;
    duration?: number;
    cargoAtDeparture?: number;
    batteryPct?: number;
    isInRange?: boolean;
};

export const StopoverPanel = ({
    locale,
    address,
    arrivalTime,
    cargoAtDeparture,
    batteryPct,
    duration,
    isInRange,
}: StopoverInfo) => {
    const date = convertISOToRelativeDate(locale, arrivalTime);

    return (
        <li className='timeline-element' data-testid='timeline-element'>
            <div className='timeline-date margin-right-10'>
                <div className='border border-width-3 border-color-white'>
                    <span className='badge badge-lg badge-muted padding-5'>
                        <span className='rioglyph rioglyph-stopover' />
                    </span>
                </div>
            </div>
            <div className='timeline-content margin-bottom-15'>
                <div className='text-medium text-size-16 text-color-darker margin-top-5 margin-bottom-5'>
                    <span className='margin-right-5'>
                        <FormattedMessage id='intl-msg:smartRoute.tour.stopOver' />
                    </span>
                    {!isNil(isInRange) && <RangeStatusIcon isWaypointInRange={isInRange} badgeSize='badge-sm' />}
                </div>
                <div className='display-flex flex-column gap-2'>
                    {gt(duration, 0) && (
                        <div>
                            <span className='rioglyph rioglyph-time text-color-gray margin-right-5' />
                            {!isNil(duration) ? <span>{convertSecondsIntoHHmmDisplay(duration)}</span> : '-'}
                        </div>
                    )}
                    <div>
                        <span className='rioglyph rioglyph-calendar text-color-gray margin-right-5' />
                        <span>{date}</span>
                    </div>

                    <div>
                        <span className='rioglyph rioglyph-map-marker text-color-gray margin-right-5' />
                        <span>{address}</span>
                    </div>

                    {!isNil(cargoAtDeparture) && (
                        <div>
                            <span className='rioglyph rioglyph-weight text-color-gray margin-right-5' />
                            <span>{cargoAtDeparture}</span>
                            <span>&nbsp;{Unit.weight}</span>
                        </div>
                    )}

                    {!isNil(batteryPct) && (
                        <div className={`${getBatteryColor(batteryPct)}`}>
                            <span className={`${getBatteryIcon(batteryPct)} margin-right-5`} />
                            <span>{batteryPct}</span>
                            <span>&nbsp;{Unit.pct}</span>
                        </div>
                    )}
                </div>
            </div>
        </li>
    );
};
